import { IKnmInspector248 } from 'APIPackage/KnmModule/interfaces/IKnmInspector248';

import { IKnmErknmFormInspector } from '../interfaces/IKnmErknmFormInspector';

type DataType = IKnmInspector248[] | null;

export function convertInspectorsFormValuesToKnmData(
  isShow4122: boolean,
  formInspectors?: IKnmErknmFormInspector[] | undefined,
): DataType {
  return (
    formInspectors?.map(item => {
      if (isShow4122) {
        return {
          fullName: item.knoInspector?.value.fullName || '',
          position: item.knoInspector?.value.position?.value || null,
          guid: item.knoInspector?.value.guid || item.listId || null,
          dateCreate: item.knoInspector?.value.dateCreate || null,
        };
      }

      return {
        fullName: item.fullName || '',
        position: item.position?.value || null,
        guid: item.guid || item.listId || null,
        dateCreate: item.dateCreate || null,
      };
    }) || null
  );
}
